import {
  createTheme,
  ThemeProvider,
  Container,
  Paper,
  Typography,
  Box,
  TextField,
  Button,
  InputAdornment,
  IconButton,
} from "@mui/material";
import React, { useState } from "react";
import logo from "../../assets/img/logo1.png";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { CHANGE_PASSWORD_VALIDATIONS } from "../../utils/Validation";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useLocation, useNavigate } from "react-router-dom";
import { ForgotPasswordService } from "../../services/LoginService";
import { useLoading } from "../../common/LoadingContext";
import { useNotificationContext } from "../../common/NotificationContext";
import { cleanInitialState } from "../../reducer/action";
import useGlobalState from "../../Context";
import { LogoutService } from "../../services/LoginService";



const ChangePassword = ({ cardFlipToggle }) => {
  const theme = createTheme();
  const navigate = useNavigate();
  const { showNotification } = useNotificationContext();
  const { setLoading } = useLoading();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const formOption = {
    resolver: yupResolver(CHANGE_PASSWORD_VALIDATIONS),
  };
  const [{ auth }, dispatch] = useGlobalState();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm(formOption);


  const handleLogout = async () => {
    try {
   setLoading(true);
   const requestBody = {
     username: auth?.ldapParam?.username?.toLowerCase(),
     loggedIn: false
   }
  const response = await LogoutService(requestBody);
  if (response.statusCode === 6) {
    // showNotification("Success", response.message, "success");
     dispatch(cleanInitialState());
     localStorage.removeItem("SPMS_INTERNAL_STATE");
     localStorage.removeItem("partTypeListItem");
     sessionStorage.removeItem("token&userId");
     localStorage.removeItem("email");
     navigate("/login");

   } else {
     showNotification("Error", response.message, "error");
   }
 } catch (err) {
   showNotification("Error", err.message ?? "Failed to Logout");
 } finally {
   setLoading(false);
 }
};

  const onSubmitClick = async (data) => {
    const values = sessionStorage.getItem("token&userId");
    const val = JSON.parse(values);

    try {
      const param = {
        password: window.btoa(data?.newPassword),
        tempPassword: window.btoa(data?.token),
        currentUserId: val.currentUserId,
        username: localStorage.getItem("email"),
      };
      setLoading(true);
      const response = await ForgotPasswordService(param);
      if (response.statusCode === 6 && response.data['error'] === false) {
        showNotification("Success", response.data.msg, "success");
      
        if(Object.keys(auth).length !== 0){
       
          if(response.data['error'] === false){
            handleLogout();
          }
         
        }
        else{
          if(response.data['error'] === false)
          {
            navigate("/login");
          }
        }
      } else {
        showNotification("Error", response.data.msg, "error");
      }
    } catch (err) {
      //showNotification("Error", err.message ?? "Failed to fetch details");
    } finally {
      setLoading(false);
    }
  };

  const onCancelClick = () => {
    navigate("/login");
  };

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs" sx={{ mt: 8 }}>
        <Paper elevation={3} sx={{ height: 450, width: 450 }}>
          <div className="logoContainer" style={{ marginBottom: "15px" }}>
            <img src={logo} alt="reliance retail" title="pbg spare" />
            <div className="projectLogo">
              <div title="R-STP" className="navBarTitle">
                R-STP
              </div>
              <div title="Spare Part Management" className="spmsHeading">
                Reliance Spare & Technical Portal
              </div>
            </div>
          </div>
          <Typography component="h1" variant="h6" color="#003f93">
            Change Password
          </Typography>
          <Box sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              label="Temporary Token"
              name="token"
              autoComplete="off"
              sx={{ width: 300 }}
              {...register("token", { required: true })}
              error={Boolean(errors?.token)}
              helperText={errors?.token?.message}></TextField>
            <TextField
              margin="normal"
              required
              fullWidth
              label="New Password"
              name="newPassword"
              autoComplete="off"
              type={showPassword ? "text" : "password"}
              sx={{ width: 300, mt: 0.5 }}
              {...register("newPassword", { required: true })}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    <IconButton
                      color="primary"
                      onClick={() => {
                        setShowPassword((prevValue) => !prevValue);
                      }}>
                      {showPassword ? (
                        <VisibilityIcon />
                      ) : (
                        <VisibilityOffIcon />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              error={Boolean(errors?.newPassword)}
              helperText={errors?.newPassword?.message}></TextField>
            <TextField
              margin="normal"
              required
              fullWidth
              label="Confirm Password"
              name="confirmPassword"
              autoComplete="off"
              type={showConfirmPassword ? "text" : "password"}
              sx={{ width: 300, mt: 0.5 }}
              {...register("confirmPassword", { required: true })}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    <IconButton
                      color="primary"
                      onClick={() => {
                        setShowConfirmPassword((prevValue) => !prevValue);
                      }}>
                      {showConfirmPassword ? (
                        <VisibilityIcon />
                      ) : (
                        <VisibilityOffIcon />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              error={Boolean(errors?.confirmPassword)}
              helperText={errors?.confirmPassword?.message}></TextField>
          </Box>
          <Button
            type="submit"
            onClick={onCancelClick}
            sx={{ mt: 2, mb: 2, mr: 1 }}
            variant="outlined">
            Cancel
          </Button>
          <Button
            type="submit"
            onClick={handleSubmit(onSubmitClick)}
            sx={{ mt: 2, mb: 2 }}
            variant="outlined">
            Save
          </Button>
        </Paper>
      </Container>
    </ThemeProvider>
  );
};
export default ChangePassword;
